const { times } = require('lodash');
const $ = require('jquery');

class RatingService {
    constructor(settings, $window, $timeout, moveFocus) {
        this.settings = settings;
        this.$window = $window;
        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
    }

    populateStars(averageRating) {
        const maxRating = this.settings.ratingreview.maxRating;
        if (!maxRating || averageRating > maxRating) return [];

        return times(maxRating, (key) => {
            const currentStar = key + 1;
            if (averageRating >= currentStar) {
                return { filled: true };
            }
            if (Math.ceil(averageRating) < currentStar) {
                return { empty: true };
            }
            return (averageRating - parseInt(averageRating) >= 0.5)
                ? { half: true }
                : { empty: true };
        });
    }

    scrollToTargetAndFocus(target = '._ratingReviewSummary') {
        const preScrollHeight = this.$window.pageYOffset;
        this.moveFocus(target);
        this.$timeout(() => {
            const ratingReviewSection = $(target)[0];
            if (ratingReviewSection) {
                ratingReviewSection.scrollIntoView();
                this.$timeout(() => {
                    const postScrollHeight = this.$window.pageYOffset;
                    const isCategoryMenuVisible = $('.categoryHeader.is-scrolled-down')[0] || $('.categoryHeader.is-default')[0];
                    const categoryMenuHeight = 40,
                        mainNavHeight = 70;

                    if (preScrollHeight >= postScrollHeight || isCategoryMenuVisible) {
                        this.$window.scrollBy(0, -categoryMenuHeight - mainNavHeight);
                    } else {
                        this.$window.scrollBy(0, -mainNavHeight);
                    }
                }, 250); // A 250ms timeout is needed to ensure any animations finish
            }
        });
    }
}

RatingService.$inject = ['Settings', '$window', '$timeout', 'MoveFocus'];

module.exports = { RatingService };



// WEBPACK FOOTER //
// ./src/shop/rating/rating.service.js